import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const SECTIONS = [
  {
    id: "aceite",
    title: "1. Aceitação dos Termos",
    body: (
      <p>
        Ao acessar e utilizar o site <strong>Viagens Orion</strong>, disponível em <a className="text-orion-orange hover:underline" href="https://viagensorion.com.br">viagensorion.com.br</a>, o usuário declara ter lido, compreendido e concordado com os presentes Termos de Uso, bem como com a nossa <Link to="/privacidade" className="text-orion-orange hover:underline">Política de Privacidade</Link>. Caso não concorde com qualquer disposição, o usuário deverá interromper imediatamente o uso do site.
      </p>
    ),
  },
  {
    id: "objeto",
    title: "2. Objeto do Site",
    body: (
      <p>
        A <strong>VIAGENS ORION</strong> disponibiliza um blog editorial de conteúdo sobre viagens, roteiros, destinos e dicas relacionadas ao turismo, com o objetivo de informar e inspirar viajantes. O conteúdo do site é oferecido a título informativo e não substitui aconselhamento personalizado de um consultor de viagens credenciado.
      </p>
    ),
  },
  {
    id: "uso-permitido",
    title: "3. Uso Permitido",
    body: (
      <>
        <p>O usuário se compromete a utilizar o site de forma lícita e ética, sendo expressamente vedado:</p>
        <ul className="list-disc ml-5 space-y-1 mt-3">
          <li>Reproduzir, copiar, distribuir ou explorar comercialmente qualquer parte do conteúdo sem autorização prévia por escrito;</li>
          <li>Utilizar mecanismos automatizados (bots, scrapers) para extração de conteúdo do site;</li>
          <li>Praticar qualquer ato que possa comprometer a segurança, a integridade ou o funcionamento do site;</li>
          <li>Publicar, transmitir ou compartilhar conteúdo ilegal, difamatório, ofensivo ou que viole direitos de terceiros.</li>
        </ul>
      </>
    ),
  },
  {
    id: "propriedade",
    title: "4. Propriedade Intelectual",
    body: (
      <p>
        Todo o conteúdo publicado no <strong>Viagens Orion</strong> — incluindo textos, imagens, logotipos, marcas, layouts, códigos e demais elementos visuais — é de titularidade exclusiva da <strong>VIAGENS ORION</strong> (SR SCABIO OPERADORA, CNPJ 37.476.039/0001-90) ou de seus respectivos licenciantes, sendo protegido pelas leis brasileiras de direitos autorais e propriedade intelectual. Qualquer uso não autorizado poderá ser passível das sanções legais cabíveis.
      </p>
    ),
  },
  {
    id: "conteudo",
    title: "5. Conteúdo Editorial e Responsabilidade",
    body: (
      <p>
        O conteúdo editorial publicado neste blog é elaborado com cuidado e curadoria, podendo contar com o auxílio de ferramentas tecnológicas para pesquisa e formatação. Contudo, as informações têm caráter informativo e podem sofrer alterações sem aviso prévio (por exemplo: preços, disponibilidade, políticas de destinos e serviços de terceiros). A <strong>VIAGENS ORION</strong> não se responsabiliza por decisões de viagem tomadas exclusivamente com base no conteúdo do blog. Recomendamos sempre confirmar informações diretamente com fornecedores oficiais antes de reservar.
      </p>
    ),
  },
  {
    id: "links",
    title: "6. Links para Sites de Terceiros",
    body: (
      <p>
        O site pode conter links para páginas externas, incluindo redes sociais, parceiros comerciais e fontes de referência. A <strong>VIAGENS ORION</strong> não se responsabiliza pelo conteúdo, políticas de privacidade ou práticas desses sites de terceiros. Ao acessá-los, o usuário fica sujeito aos termos e condições próprios de cada um.
      </p>
    ),
  },
  {
    id: "publicidade",
    title: "7. Publicidade e Programas de Anúncios",
    body: (
      <p>
        Este site utiliza o serviço <strong>Google AdSense</strong> e pode exibir anúncios de terceiros como forma de sustentar sua operação. Detalhes sobre os cookies utilizados na publicidade, incluindo o cookie DoubleClick DART do Google, estão descritos em nossa{" "}
        <Link to="/privacidade" className="text-orion-orange hover:underline">Política de Privacidade</Link>. O usuário reconhece que o conteúdo publicitário exibido não implica endosso pela Viagens Orion.
      </p>
    ),
  },
  {
    id: "cupons",
    title: "8. Cupons e Ofertas",
    body: (
      <p>
        Cupons de desconto e ofertas veiculados no blog (ex.: cupom <strong>TURISTAR</strong>) são benefícios oferecidos pela <strong>VIAGENS ORION</strong> em suas próprias reservas e podem ser alterados, suspensos ou encerrados a qualquer tempo, sem aviso prévio. Regras específicas de cada cupom serão comunicadas no momento da utilização junto a um consultor de viagens.
      </p>
    ),
  },
  {
    id: "disponibilidade",
    title: "9. Disponibilidade do Serviço",
    body: (
      <p>
        A <strong>VIAGENS ORION</strong> envidará esforços razoáveis para manter o site disponível e operante, porém não garante que ele estará livre de interrupções, falhas técnicas ou indisponibilidades causadas por manutenção, atualização, ataques cibernéticos ou eventos alheios ao seu controle. Reserva-se o direito de suspender ou encerrar o funcionamento do site a qualquer momento.
      </p>
    ),
  },
  {
    id: "alteracoes",
    title: "10. Alterações destes Termos",
    body: (
      <p>
        A <strong>VIAGENS ORION</strong> pode atualizar estes Termos de Uso a qualquer momento para refletir alterações operacionais, legais ou regulatórias. Recomenda-se ao usuário revisar esta página periodicamente. O uso contínuo do site após qualquer atualização implica na aceitação das condições revisadas.
      </p>
    ),
  },
  {
    id: "lei",
    title: "11. Lei Aplicável e Foro",
    body: (
      <p>
        Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca do domicílio do consumidor para dirimir quaisquer controvérsias oriundas destes Termos, sem prejuízo das demais garantias asseguradas pelo Código de Defesa do Consumidor.
      </p>
    ),
  },
  {
    id: "contato",
    title: "12. Contato",
    body: (
      <p>
        Dúvidas, sugestões ou solicitações relacionadas a estes Termos de Uso podem ser encaminhadas pelo e-mail{" "}
        <a className="text-orion-orange hover:underline" href="mailto:contato@viagensorion.com.br">contato@viagensorion.com.br</a>.
      </p>
    ),
  },
];

export default function Termos() {
  useEffect(() => {
    document.title = "Termos de Uso | Viagens Orion";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", "Termos de Uso do Viagens Orion — condições para utilização do site, propriedade intelectual, publicidade e responsabilidades.");
  }, []);

  return (
    <main className="bg-white text-orion-purple min-h-screen flex flex-col" data-testid="terms-page">
      <Header />
      <section className="bg-orion-purple text-white">
        <div className="container-orion py-16 md:py-20">
          <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-orion-gold/80 hover:text-orion-orange mb-6" data-testid="terms-back">
            <ArrowLeft size={14} /> Voltar ao Blog
          </Link>
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.32em] text-orion-gold mb-5">
            <FileText size={14} /> Documento legal
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight">Termos de Uso</h1>
          <p className="mt-5 text-white/70 text-sm max-w-2xl">
            Última atualização: {new Date().toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" })}.
            Regras e condições para utilização do Viagens Orion.
          </p>
        </div>
      </section>

      <section className="container-orion py-14 md:py-20 grid lg:grid-cols-[260px_1fr] gap-12">
        <aside className="hidden lg:block">
          <div className="sticky top-28 text-xs">
            <div className="uppercase tracking-[0.28em] text-orion-purple/50 mb-3">Sumário</div>
            <ul className="space-y-2">
              {SECTIONS.map((s) => (
                <li key={s.id}>
                  <a href={`#${s.id}`} className="text-orion-purple/70 hover:text-orion-orange transition-colors leading-snug block">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </aside>

        <article className="max-w-3xl text-orion-purple/85 leading-relaxed text-[15px] space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.id} id={s.id} className="scroll-mt-28">
              <h2 className="font-serif text-2xl md:text-3xl text-orion-purple mb-3">{s.title}</h2>
              <div className="space-y-3">{s.body}</div>
            </section>
          ))}

          <div className="border-t border-orion-purple/10 pt-8 mt-12 text-sm text-orion-purple/60">
            Contato:{" "}
            <a className="text-orion-orange hover:underline font-medium" href="mailto:contato@viagensorion.com.br" data-testid="terms-contact-email">
              contato@viagensorion.com.br
            </a>
          </div>
        </article>
      </section>
      <Footer />
    </main>
  );
}
